import $ from 'jquery';

const FORM_ELEMENT_CONTAINER_SELECTOR = '.form-element-container';
export const INPUT_GROUP_CONTAINER_SELECTOR = '.input-group-container';
const COMBOBOX_ELEMENT_SELECTOR = '.combobox-element';
const COMBOBOX_HIDDEN_INPUT_SELECTOR = '.combobox-hidden-input';

export function initJQueryPlugin(){
    (function ( $ ) {
    
        $.fn.form = function() {
            return formElement( this );
        };
    
    }( $ ));
}

export function formElement( $element, $context = null ){
        
    var $element = $( $element, $context );
    
    /**
     * Resolve combobox element (user could have selected combobox parent element or the hidden input.)
     */
    if ( $element.is( COMBOBOX_HIDDEN_INPUT_SELECTOR ) ){
        $element = $element.closest( COMBOBOX_ELEMENT_SELECTOR );
    }
    
    return new FormElement( $element );
    // TODOUI return different subclass depending on whether input, checkbox etc.
    // TODOUI also allow updating of display values
}

class FormElement{
    
    /**************************************************************************
     * CONSTRUCTOR
     **************************************************************************/
    constructor( $element ){
        this.$element = $element;
    }
    
    /**************************************************************************
     * READONLY/EDITABLE
     **************************************************************************/
    makeEditable(){
        this.$element.removeAttr( 'readonly' );
        this.$element.closest(  ).removeAttr( 'data-readonly' );
        return this.$element;
    }
    
    makeReadonly(){
        this.$element.attr( 'readonly', 'readonly' );
        this.$element.closest( INPUT_GROUP_CONTAINER_SELECTOR ).attr( 'data-readonly', 'true' );
        return this.$element;
    }
    
    setReadonly( readonly ){
        if ( readonly ){
            this.makeReadonly();
        } else {
            this.makeEditable();
        }
    }
    
    setEditable( editable ){
        return this.setReadonly( !editable );
    }
    
    /**************************************************************************
     * ENABLED/DISABLED
     **************************************************************************/
    enable(){
        if ( this.isCombobox() ){
            this.$element.find( COMBOBOX_HIDDEN_INPUT_SELECTOR ).removeAttr( 'disabled' );
            this.$element.find( '.combobox-button-trigger' ).removeAttr( 'disabled' );
        } 
        this.$element.removeAttr( 'disabled' );
        this.$element.closest( INPUT_GROUP_CONTAINER_SELECTOR ).removeAttr( 'data-disabled' );
        return this.$element;
    }
    
    disable(){
        if ( this.isCombobox() ){
            this.$element.find( COMBOBOX_HIDDEN_INPUT_SELECTOR ).attr( 'disabled', 'disabled' );
            this.$element.find( '.combobox-button-trigger' ).attr( 'disabled', 'disabled' );
        } 
        this.$element.attr( 'disabled', 'disabled' );
        this.$element.closest( INPUT_GROUP_CONTAINER_SELECTOR ).attr( 'data-disabled', 'true' );
        return this.$element;
    }
    
    setEnabled( enabled ){
        if ( enabled ){
            return this.enable();
        } else {
            return this.disable();
        }
    }
    
    setDisabled( disabled ){
        return this.setEnabled( !disabled );
    }
    
    /**************************************************************************
     * HIDE/SHOW
     **************************************************************************/
    show(){
        this.$element.closest( FORM_ELEMENT_CONTAINER_SELECTOR ).show();
        return this.$element;
    }
    
    hide(){
        this.$element.closest( FORM_ELEMENT_CONTAINER_SELECTOR ).hide();
        return this.$element;
    }
    
    setShown( shown ){
        if ( shown ){
            return this.show();
        } else {
            return this.hide();
        }
    }
    
    setHidden( hidden ){
        return this.setShown( !hidden );
    }
    
    // TODOUI functions for setting mandatory, changing label etc
    
    /**************************************************************************
     * ID
     **************************************************************************/
    setId( id ){
        if ( this.isCombobox() ){
            this.$element.attr( 'id' , id + '-combobox' );
            
            var $trigger = this.$element.find( '.combobox-button-trigger' );
            $trigger.attr( 'id', id + '-trigger' );
            $trigger.attr( 'aria-controls', id + '-listbox' );
            
            var $popover = this.$element.find( '.combobox-popover' );
            $popover.attr( 'id', id + '-popover' );
            
            var $searchInput = this.$element.find( '.combobox-search-input' );
            $searchInput.attr( 'aria-labelledby', id + '-trigger' );
            $searchInput.attr( 'aria-controls', id + '-listbox' );
            
            var $listbox = this.$element.find( '.combobox-listbox' );
            $listbox.attr( 'id', id + '-listbox' );
            $listbox.attr( 'aria-labelledby', id + '-trigger' );
            
            var $hiddenInput = this.$element.find( COMBOBOX_HIDDEN_INPUT_SELECTOR );
            $hiddenInput.attr( 'name', id );
            $hiddenInput.attr( 'id', id );
            
        } else {
            this.$element.attr( 'id', id );
        }
        
        return this.$element;
    }
    
    /**************************************************************************
     * DROPDOWN FUNCTIONS - OPTIONS
     **************************************************************************/
    addOption( value, label ){
        // TODOUI have this accept varying length argument, 
        // object, array format etc
        if ( this.isCombobox() ){
            var $listbox = this.$element.find( '.combobox-listbox' );
            // TODOUI complete this function.
            
        } else if (this.$element.is( 'select' ) ){
            this.$element.append($("<option value=\"" + value + "\">" + label + "</option>"));
        }
        
        return this.$element;
    }
    
    /**************************************************************************
     * UTILITY - INPUT TYPE
     **************************************************************************/
    isCombobox(){
        return this.$element.is( COMBOBOX_ELEMENT_SELECTOR );
    }
}
